export default {
  hero: {
    title: 'ABOUT US',
    subtitle:
      "Having been in the market for 20 years, we’re a strategic Innovation and Digital Transformation consulting company. Our specialty is to boost business. We integrate technology, people and processes to improve our clients' results.",
  },
}
